import styled from "styled-components";
import { CheckBox, Tooltip } from "@dealer-center/core-components";
import { memo } from "react";
import type { resources } from "@dealer-center/ddc-pages-resources-interface";

interface DashboardResourcesInterface {
  resources: resources[];
  letter: string;
  onChange: (resource: string, enabled: boolean) => void;
  disabled: boolean;
}
const StyledLetterDetailArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div {
    @media (max-width: 768px) {
      min-width: 100%;
    }
    @media (min-width: 768px) {
      min-width: 50%;
    }
    @media (min-width: 992px) {
      min-width: 33.3%;
    }
  }
`;
const StyledCheckBoxArea = styled.div``;
const StyledConfigurableResourceLabel = styled.span``;
const StyledNonConfigurableResourceLabel = styled.span`
  color: #5c0000;
  border-bottom: 1px dashed #5c0000;
  svg {
    vertical-align: middle;
  }
`;

const LetterDetailArea = memo(
  ({ resources, letter, onChange, disabled }: DashboardResourcesInterface) => {
    return (
      <StyledLetterDetailArea>
        {resources.map(resource => (
          <StyledCheckBoxArea key={resource.name}>
            <CheckBox
              checked={resource.granted}
              disabled={disabled || !resource.configurable}
              id={`dashboard-resources-${letter}-${resource.name}-checkbox`}
              label={
                resource.configurable ? (
                  <StyledConfigurableResourceLabel>
                    {resource.name}
                  </StyledConfigurableResourceLabel>
                ) : (
                  <StyledNonConfigurableResourceLabel>
                    <Tooltip
                      position="top"
                      size="large"
                      toolTipContent={"Non-Configurable Resource"}
                    >
                      <div>{resource.name}</div>
                    </Tooltip>
                  </StyledNonConfigurableResourceLabel>
                )
              }
              name={resource.name}
              value={`dashboard-resources-${letter}-${resource.name}-checkbox`}
              onChange={event => {
                onChange(resource.name, event.target.value?.checked ?? false);
              }}
            />
          </StyledCheckBoxArea>
        ))}
      </StyledLetterDetailArea>
    );
  },
  (
    prevProps: DashboardResourcesInterface,
    nextProps: DashboardResourcesInterface
  ) => {
    return (
      prevProps.disabled === nextProps.disabled &&
      prevProps.onChange === nextProps.onChange &&
      prevProps.letter === nextProps.letter &&
      prevProps.resources.length === nextProps.resources.length &&
      prevProps.resources.every(
        (resource, index) => resource === nextProps.resources[index]
      )
    );
  }
);

LetterDetailArea.displayName = "LetterDetailArea";

export default LetterDetailArea;
